import { LogNguoiDung } from "../lognguoidung/LogNguoiDung";

export class DonNgoaiGio {
    "id": number;
    "idNhanVien": number;
    "idNguoiDuyet": number;
    "idNguoiYKien": number | undefined;
    "tenNhanVien": string;
    "donVi": string;
    "tenNguoiDuyet": string;
    "ngayKhoiTao": string;
    "ngayCapNhat": string;
    "tenNguoiYKien": string;
    "ngay": Date;
    "soGio": number;
    "lyDo": string;
    "kinhGui": string;
    "diaDiemLamViec": string;
    "trangThai": number;
    "quyenPheDuyet": boolean;
    "quyenSua": boolean;
    "quyenYKien": boolean;
    "logs": Array<LogNguoiDung>;
}

export class ThongTinDonNgoaiGio {
    "id": number;
    "nhanVien": string;
    "donVi": string;
    "nguoiDuyet": string;
    "nguoiYKien": string;
    "ngay": Date;
    "soGio": number;
    "trangThai": number;
}

export class TimKiemDonNgoaiGioPagingResponse {
    "data": Array<DonNgoaiGio>;
    "recordsTotal": number;
    "maxPage": number;
    "pageCurrent": number;
    "pageListShow": Array<number>;
}

export class TimKiemDonNgoaiGioRequest {
    "tuKhoa": string | null;
    "ngayTaoTuNgay": Date | null;
    "ngayTaoDenNgay": Date | null;
    "ngayDangKyTuNgay": Date | null;
    "ngayDangKyDenNgay": Date | null;
}
